import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=5f0ac9b4"
import script from "./contact-form.vue?vue&type=script&lang=js"
export * from "./contact-form.vue?vue&type=script&lang=js"
import style0 from "./contact-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports